<template>
  <div class="lp">
    <div class="a">
      <div :class="[lcheck ? 'c' : 'd']">
        <p>全文共{{ contentCount }}个字</p>
        <el-progress
          v-if="lcheck"
          type="circle"
          :stroke-width="3"
          :width="95"
          :percentage="perNumber"
        ></el-progress>
        <p v-if="!lcheck">预计 {{ contentTime }}秒 完成</p>
      </div>
      <div :class="[lcheck ? '' : 'd']">
        <button class="btn" @click="checkin">
          {{ rightTitle === "智能纠错" ? "开始纠错" : "开始检测" }}
        </button>
        <button :class="[lcheck ? 'btn2' : 'btn1']" @click="cancel">
          {{ lcheck ? "中断" : "取消" }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { SendPostData } from "../../assets/script/model";
import tinymce from "tinymce";
import { mapActions } from "vuex";
import findWords from "../../assets/script/utils/findWords";
export default {
  name: "SearchLoading",
  data() {
    return {
      perNumber: this.percentage,
      lcheck: this.check,
      lptage: this.ptage
    };
  },
  props: {
    check: {
      type: Boolean,
      default: false
    },
    percentage: {
      type: Number,
      default: 0
    },
    ptage: {
      type: Object,
      default: null
    },
    contentCount: {
      type: Number,
      default: 0
    },
    contentTime: {
      type: Number,
      default: 0
    },
    checkType: {
      type: String,
      default: ""
    }
  },
  computed: {
    rightTitle: {
      get() {
        return this.$store.state.contents.rightTitle;
      },
      set(val) {
        this.$store.state.contents.rightTitle = val;
      }
    },
    wycShow: {
      get() {
        return this.$store.state.contents.wycShow;
      },
      set(val) {
        this.$store.state.contents.wycShow = val;
      }
    },
    sentence: {
      get() {
        return this.$store.state.editorControl.sentence;
      },
      set(val) {
        return (this.$store.state.editorControl.sentence = val);
      }
    },
    isOriginal: {
      get() {
        return this.$store.state.editorControl.isOriginal;
      },
      set(val) {
        return (this.$store.state.editorControl.isOriginal = val);
      }
    },
    isShowLoading: {
      get() {
        return this.$store.state.editorControl.isShowLoading;
      },
      set(val) {
        this.$store.state.editorControl.isShowLoading = val;
      }
    }
  },
  mounted() {
    this.listenMessage();
  },
  methods: {
    ...mapActions("api", ["APermission"]),
    listenMessage() {
      let that = this;
      window.addEventListener("message", function(e) {
        if (e.data && e.data.cmd === "_5118_Response_Message_Content") {
          if (
            !e.data.isclose &&
            (e.data.btn === "detection" || e.data.btn === "aidetection")
          ) {
            let getMsg = e.data.data;
            if (getMsg) {
              clearInterval(that.lptage);
              that.isShowLoading = false;
              that.$emit("CheckOver", getMsg);
            }
          }
          if (
            !e.data.isclose &&
            (e.data.btn === "original" || e.data.btn === "aioriginal")
          ) {
            let getMsg = e.data.data;
            if (getMsg) {
              clearInterval(that.lptage);
              that.isShowLoading = false;
              that.$emit("CheckOver", getMsg);
            }
          }
          if (!e.data.isclose && e.data.btn === "gettxt") {
            let getTxt = e.data.data.txt;
            let sendData = new SendPostData();
            sendData.btn = "aibannedword";
            sendData.data = { txt: getTxt };
            that.SendMessage(sendData);
          }
          if (!e.data.isclose && e.data.btn === "aibannedword") {
            let getMsg = e.data.data;
            if (getMsg) {
              that.isShowLoading = false;
              clearInterval(that.lptage);
              that.$emit("CheckOver", getMsg);
            }
          }
        }
      });
    },
    async checkin() {
      let checkName = "";
      if (this.checkType === "error") checkName = "wycdetection";
      if (this.checkType === "original") checkName = "wycoriginalfull";
      if (this.checkType === "prohibited") checkName = "illegaltextcheck";
      let result = await this.APermission({ SysName: checkName });
      if (result.errorCode > 0) {
        this.$message({
          message: result.errorMess,
          type: "error",
          showClose: true
        });
        return;
      }
      if (result.data > 0 || result.data === -1) {
        this.lcheck = true;
        this.isShowLoading = true;
        if (this.isOriginal) {
          this.checkOriginal(this.sentence);
        } else {
          this.sendDetection(this.checkType);
        }
        let num = 1;
        this.lptage = setInterval(() => {
          this.perNumber = num;
          num += 1;
          if (num >= 100) {
            clearInterval(this.lptage);
          }
        }, 10 * this.contentTime);
      } else {
        this.insertConfig.showUpgrade(true, "获取更多使用次数");
        // let getTitle = "";
        // if (this.checkType === "error") getTitle = "智能纠错";
        // if (this.checkType === "original") getTitle = "原创检测";
        // if (this.checkType === "prohibited") getTitle = "违规检测";
        // this.$message({
        //   message: getTitle + "次数已用尽",
        //   type: "error",
        //   showClose: true
        // });
      }
    },
    cancel() {
      this.lcheck = false;
      this.isShowLoading = false;
      this.perNumber = 0;
      clearInterval(this.lptage);
    },
    clearClass() {
      let getContent = tinymce.activeEditor.getBody().innerHTML;
      let reg = /<span class="proBackColor">([^>]*?)<\/span>/gi;
      let matches = [];
      while ((matches = reg.exec(getContent)) != null) {
        let innerWords = tinymce.activeEditor
          .getBody()
          .innerHTML.replace(matches[0], matches[1]);
        tinymce.activeEditor.setContent(innerWords);
      }

      getContent = tinymce.activeEditor.getBody().innerHTML;
      reg = /<span class="errBackColor">([^>]*?)<\/span>/gi;
      matches = [];
      while ((matches = reg.exec(getContent)) != null) {
        let innerWords = tinymce.activeEditor
          .getBody()
          .innerHTML.replace(matches[0], matches[1]);
        tinymce.activeEditor.setContent(innerWords);
      }

      getContent = tinymce.activeEditor.getBody().innerHTML;
      reg = /<span class="[oriBackColor1|oriBackColor2|oriBackColor3]+">([^>]*?)<\/span>/gi;
      matches = [];
      while ((matches = reg.exec(getContent)) != null) {
        let innerWords = tinymce.activeEditor
          .getBody()
          .innerHTML.replace(matches[0], matches[1]);
        tinymce.activeEditor.setContent(innerWords);
      }
    },
    checkOriginal(str) {
      // this.clearClass();
      findWords.closeAllHighlight();
      let sendData = new SendPostData();
      sendData.btn = "aioriginal";
      let postlist = [];
      postlist.push(str);
      sendData.data = { txt: postlist };
      this.SendMessage(sendData);
      this.sentence = "";
      this.isOriginal = false;
    },
    sendDetection(type) {
      if (this.wycShow) {
        let sendData = new SendPostData();
        if (type === "error") sendData.btn = "detection";
        if (type === "original") sendData.btn = "original";
        if (type === "prohibited") sendData.btn = "gettxt";
        this.SendMessage(sendData);
      } else {
        let sendData = new SendPostData();
        let content = tinymce.activeEditor.getBody().innerText + "\n";
        if (type === "error") {
          sendData.btn = "aidetection";
          // this.clearClass();
          findWords.closeAllHighlight();
        }
        if (type === "prohibited") {
          // this.clearClass();
          findWords.closeAllHighlight();
          sendData.btn = "aibannedword";
        }
        if (type === "original") {
          // this.clearClass();
          findWords.closeAllHighlight();
          sendData.btn = "aioriginal";
          let postlist = [];
          let content_list = content.split("\n");
          for (let item of content_list) {
            if (item !== "") {
              postlist.push(item);
            }
          }
          sendData.data = { txt: postlist };
        } else {
          sendData.data = { txt: content };
        }
        this.SendMessage(sendData);
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/style/color";
.lp {
  padding: 0 15px;
  text-align: center;
}
.a {
  background-color: @boxback-color;
  line-height: 30px;
  margin: 10px 0 10px 0;
  padding-left: 10px;
  border-radius: 5px;
  height: 210px;
}
.btn {
  background-color: @button-color;
  padding: 3px 9px;
  color: #fff;
  border: 1px solid @button-color;
  border-radius: 10px;
  cursor: pointer;
  margin-right: 8px;
}
.btn1 {
  .btn;
  color: #fff;
  background-color: #888888;
  border: 0;
  padding: 5px 20px;
}
.btn2 {
  .btn;
  background-color: #ff5653;
  border: 0;
  padding: 5px 20px;
}
.c {
  padding-top: 20px;
}
.d {
  padding-top: 50px;
}
</style>
